import CoolblueLogo from './CoolblueLogo.js';
export default CoolblueLogo;
//# sourceMappingURL=index.js.map